import { defineStore } from "pinia";
import { ref } from "vue";
import { IUserAccountCreationResponse } from "@/common/api/unifiedPortal/interfaces";

export const useAolAccountStore = defineStore("aolAccount", () => {
  const errorResponseMessage = ref("");
  const createAccountResponse = ref<IUserAccountCreationResponse>();
  const errorResponseStatus = ref<number>();
  const token = ref("");
  const sku = ref("");
  const hasAddedNewAolSubscription = ref<boolean>(false);
  const isSmbEmail = ref(false);
  const isNonEmptyAccount = ref(false);

  function resetResponses() {
    //Clear the previous response
    createAccountResponse.value = undefined;
    //Clear the error states in store
    errorResponseMessage.value = "";
    errorResponseStatus.value = undefined;

    hasAddedNewAolSubscription.value = false;

    isSmbEmail.value = false;
  }

  return {
    errorResponseMessage,
    createAccountResponse,
    errorResponseStatus,
    token,
    sku,
    hasAddedNewAolSubscription,
    resetResponses,
    isSmbEmail,
    isNonEmptyAccount,
  };
});
